export enum MetadataFlagTypes {
  Standard = 1,
  Neutral = 2,
}
